import React from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import HeadingH1 from "../../../utls/HeadingH1";

const AwardsBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/15.%20Awards%20&%20Achievements.webp"
            alt="Awards Banner"
            className="w-100"
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
          {imageLoaded ? (
            <div className="ctm-text position-absolute text-white mt-xxl-4 mt-3">
              <p className="fs4 text-uppercase busy">Celebrating</p>
              <HeadingH1 className="banner-headings w-75">
                Honoring Our Superior Travel Experience
              </HeadingH1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  Recognitions that drive us forward! Every honor we receive is
                  a demonstration of our dedication, innovation, and exceptional
                  service delivered to our precious clients.
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default AwardsBanner;
